(function ($) {
    console.log("버전 [250319v1.0.8]");

    $(document).ready(function() {
        const url = window.location.href;

        // [언어 설정]
        let locale = "KOR";
        const hostname = window.location.hostname;

        const korDomains = [
            "standoil.kr",
            "m.standoil.kr",
            "skin-skin40.standoil.kr",
            "skin-mobile36.standoil.kr",
            "standoil.cafe24.com/skin-skin40",
            "standoil.cafe24.com/skin-mobile36",
        ];
        const engDomains = [
            "en.standoil.kr",
            "m.en.standoil.kr",
            "skin-skin26--shop2.standoil.kr",
            "skin-mobile22--shop2.standoil.kr",
            "standoil.cafe24.com/shop2/skin-skin26",
            "standoil.cafe24.com/shop2/skin-mobile22",
        ];
        const japDomains = ["standoil.jp"];

        if (engDomains.includes(hostname)) {
            locale = "ENG";
        } else if (japDomains.includes(hostname)) {
            locale = "JAP";
        } else if (korDomains.includes(hostname)) {
            locale = "KOR";
        }

        console.log("Locale determined:", locale);

        console.log("[언어 설정]", locale);

        // [주소 폼 설정]
        if($('#address-form').length !== 0) {
            const addressForm = new AddressForm(common_aAddrInfo, locale);
        }

        // [URL 파라미터 조회]
        function getUrlParameter(sParam) {
            var sPageURL = window.location.search.substring(1),
                sURLVariables = sPageURL.split('&'),
                sParameterName,
                i;
            for (i = 0; i < sURLVariables.length; i++) {
                sParameterName = sURLVariables[i].split('=');

                if (sParameterName[0] === sParam) {
                    return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
                }
            }
        };

        // [스크롤 컨테이너 높이 설정]
        function setStickyContainerHeight(container, duration, callback) {
            var vh = window.innerHeight;
            var height = container.height();
            var new_height = vh * duration;
            container.css("height", new_height);
            if (callback) callback();
        }

        // [값 매핑]
        function mapValue(value, inMin, inMax, outMin, outMax) {
            return ((value - inMin) * (outMax - outMin)) / (inMax - inMin) + outMin;
        }

        const googleSheetURL = 'https://script.google.com/macros/s/AKfycbxJYVoDY__YFKxvH1R00qX_mqgZSH9pTnBnXaELHitOxJug4gYyKeKa66wn1xbyLzwR/exec';
        const eventType = getUrlParameter('type') || null;

        // [모바일 여부 확인]
        let isMobile = false;
        if(url.includes('m.')) isMobile = true;
        if(url.includes('skin-mobile')) isMobile = true;

        $('.page').addClass(isMobile ? 'mobile-page' : 'pc-page').addClass(locale);
        $('#promotion-tabs').addClass(isMobile ? 'mobile-page' : 'pc-page').addClass(locale);

        if(window.innerWidth > 768) {
            $('.page').removeClass('mobile-page');
            $('.page').addClass('pc-page');
            $('#promotion-tabs').removeClass('mobile-page');
            $('#promotion-tabs').addClass('pc-page');
            isMobile = false;
        } else {
            $('.page').removeClass('pc-page');
            $('.page').addClass('mobile-page');
            $('#promotion-tabs').removeClass('pc-page');
            $('#promotion-tabs').addClass('mobile-page');
            isMobile = true;
        }

        $(window).on('resize', function () {
            if(window.innerWidth > 768) {
                $('.page').removeClass('mobile-page');
                $('.page').addClass('pc-page');
                $('#promotion-tabs').removeClass('mobile-page');
                $('#promotion-tabs').addClass('pc-page');
                isMobile = false;
            } else {
                $('.page').removeClass('pc-page');
                $('.page').addClass('mobile-page');
                $('#promotion-tabs').removeClass('pc-page');
                $('#promotion-tabs').addClass('mobile-page');
                isMobile = true;
            }
        });

        if(isMobile) {
            console.log('모바일인 경우 이벤트 처리');
            $('.school-section .btn-wrap').on('click', function () {
                // 새창으로 열기
                console.log($('.school-section .btn-wrap a').attr('href'));
                window.open($('.school-section .btn-wrap a').attr('href'), '_blank');
            });
        }

        const message = {
            KOR: {
                formLoading: "제출중",
                formAllRequired: "모든 항목을 입력해주세요.",
                formSubmit: "제출하기",
                formSuccess: "제출완료",
                viewPrivacy: "내용 열기",
                closePrivacy: "내용 닫기",
                shareTitle: "standoil 친구 찾기 이벤트",
                shareMessage: "standoil 친구 찾기 이벤트",
            },
            ENG: {
                formLoading: "Submitting",
                formAllRequired: "Please fill in all fields.",
                formSubmit: "Submit",
                formSuccess: "Submit Success",
                viewPrivacy: "View",
                closePrivacy: "Close",
                shareTitle: "Find a friend",
                shareMessage: "Find a friend",
            },
            JAP: {
                formLoading: "送信中",
                formAllRequired: "すべてのフィールドを入力してください。",
                formSubmit: "送信",
                formSuccess: "送信完了",
                viewPrivacy: "見る",
                closePrivacy: "閉じる",
                shareTitle: "友達にstandoilを共有",
                shareMessage: "友達にstandoilを共有",
            },
        };

        const controller = new ScrollMagic.Controller({
            loglevel: 4,
        });

        console.log('[eventType]', eventType);

        // [이벤트 타입] 테스트 파라미터 처리
        if (eventType) {
            switch (eventType) {
                // 종료, 진행중
                case 'end':
                    $("#btn-view-product").removeClass('d-none');
                    $("#img-section").removeClass('fold');
                    $("#school-section").addClass('d-none');
                    $(".notice").addClass('d-none');
                    break;
                case 'progress':
                    break;
                default:
                    break;
            }
        }

        const imageDomain = locale == 'JAP' ? 'https://standoil.kr' : '';
        console.log("[모바일 여부]", isMobile);

        let now = new Date(new Date().toLocaleString('en-US', { timeZone: 'Asia/Seoul' }));

        const tapList = [
            {
                id: 1,
                name: '25SS COLLECTION',
                cateNo: 399,
                startDate: '2025-02-28T10:57:00+09:00',
                endDate: '2025-03-05T10:56:59+09:00'
            },
            {
                id: 2,
                name: '25SS 1ST DROP',
                cateNo: 482,
                startDate: '2025-03-05T10:57:00+09:00',
                endDate: '2025-03-12T10:56:59+09:00'
            },
            {
                id: 3,
                name: '25SS 2ND DROP',
                cateNo: 483,
                startDate: '2025-03-12T10:57:00+09:00',
                endDate: '2025-03-19T10:56:59+09:00'
            },
            {
                id: 4,
                name: '25SS 3RD DROP',
                cateNo: 484,
                startDate: '2025-03-19T10:57:00+09:00',
                endDate: '2025-03-19T23:59:59+09:00'
            },
            // {
            //     id: 5,
            //     name: '25SS COLLECTION',
            //     cateNo: 399,
            //     startDate: '2025-03-20T00:00:00+09:00',
            // }
            {
                id: 5,
                name: '25SS 3RD DROP',
                cateNo: 484,
                startDate: '2025-03-20T00:00:00+09:00',
            }
        ];

        // 3/5(수) 00:00 프레임 변경 시점
        const changeFrameDate = new Date('2025-03-05T00:00:00+09:00');
        // 3/20(목) 00:00 이벤트 종료 디자인 적용 시점
        const eventEnd = new Date('2025-03-20T00:00:00+09:00');

        // 현재 날짜에 따라서 카테고리와 텍스트 셋팅
        // const tapParam = getUrlParameter('tap') ? getUrlParameter('tap') : (eventType == 'progress' || eventType == 'end') ? 1 : null;
        const tapParam = getUrlParameter('tap') ? getUrlParameter('tap') : null;

        console.log('[tapParam] 전달받은 탭 번호', tapParam);
        console.log('[now] 현재 날짜', now);

        if (tapParam) {
            now = new Date(tapList.find((item) => Number(item.id) == Number(tapParam)).startDate);
            console.log('[now] 테스트 파라미터로 변경된 날짜', now);
        }

        let tap = tapList.find(item => {
            // 명시적으로 한국 시간으로 파싱
            const startDate = new Date(new Date(item.startDate).toLocaleString('en-US', { timeZone: 'Asia/Seoul' }));
            const endDate = item.endDate ? new Date(new Date(item.endDate).toLocaleString('en-US', { timeZone: 'Asia/Seoul' })) : null;

            // console.log('[startDate] 시작 날짜', startDate);
            // console.log('[endDate] 종료 날짜', endDate);

            if (!endDate) {
                return now >= startDate;
            }

            // console.log('[now >= startDate]', now >= startDate);
            // console.log('[now <= endDate]', now <= endDate);

            return now >= startDate && now <= endDate;
        });

        const isEventEnd = new Date(eventEnd).getTime() < new Date(now).getTime();
        const isChangeFrame = new Date(changeFrameDate).getTime() < new Date(now).getTime();

        tap = tapList.find(item => {
            return item.id == 5;
        });

        if(isEventEnd || tap.id == 5) {
            $("#btn-view-product").removeClass("d-none");
            $("#img-section").removeClass("fold");
            $("#school-section").addClass("d-none");
            $(".notice").addClass("d-none");

            $('#btn-view-product').on('click', function () {
                // 스크롤 이벤트
                if(locale == 'KOR' || locale == 'ENG') {
                    window.scrollTo({
                        top: $('#product-wrap').offset().top - 100,
                        behavior: 'smooth'
                    });
                } else if (locale == 'JAP') {
                    window.scrollTo({
                        top: $('#promotion-tabs').offset().top - 100,
                        behavior: 'smooth'
                    });
                }
            });
        }

        console.log('[tap] 현재 탭', tap);

        // [인트로] 이미지 노출
        let introImageLength = isChangeFrame ? 147 : 68;
        if(eventType == 'end') introImageLength = 147;
        const introImageDuration = introImageLength * 65;
        const introSequenceHolder = $('#intro-section .sequence-holder');

        if(tapParam && tap) {
            if(tap.id !== 5) {
                $(".page").append(
                    `<div class="tap-info">
                        <div class="tap-info-title">TAP ${tap.id} ${tap.name} 진행 예시 화면입니다. <br>[${formatDateTime(now, true)} 기준 예시]</div>
                        <div class="tap-info-desc mt-12">
                            <p>- 적용 카테고리 : ${tap.cateNo}</p>
                            <p>- 적용 편지지 프레임 : ${introImageLength}</p>
                        </div>
                        <div class="tap-info-desc mt-12 drop-info">드랍 진행 기간 <br> [${formatDateTime(tap.startDate)} ~ ${formatDateTime(tap.endDate)}]</div>
                        <div id="tap-info-limit" class="d-none tap-info-desc mt-12">
                            <p class="tap-info-desc mt-12">적용 당첨 제한 수량</p>
                            <p class="tap-info-desc" id="tap-info-desc"></p>
                        </div>
                    </div>`
                );
            } else {
                $(".page").append(
                    `<div class="tap-info">
                        <div class="tap-info-title">TAP ${tap.id} ${tap.name} 진행 예시 화면입니다. <br>[${formatDateTime(now, true)} 기준 예시]</div>
                        <div class="tap-info-desc mt-12">
                            <p>- 적용 카테고리 : ${tap.cateNo}</p>
                            <p>- 적용 편지지 프레임 : ${introImageLength}</p>
                        </div>
                        <div class="tap-info-desc mt-12 drop-info">드랍 종료</div>
                    </div>`
                );
            }
        }

        for (let i = 0; i < introImageLength; i++) {
            // 프리로드 이미지 목록 추가
            const img = $('<img preload>');
            let index = i + 1;
            if(index == 1) img.addClass('active');
            if (index.toString().length === 1) {
                index = '00' + index;
            } else if (index.toString().length === 2) {
                index = '0' + index;
            }
            img.attr('src', imageDomain + `/web/25ss/assets/letter/${isMobile ? 'mo' : 'pc'}/letter_${index}.png`);
            introSequenceHolder.find('.sequence-holder-inner').append(img);
            img.addClass(`index-${index}`);
        }
        introSequenceHolder.find('img').eq(0).addClass('active');

        $(window).on("resize", function () {
            $('#intro-section .sequence-holder-inner img').each(function (index, item) {
                let newIndex = index + 1;
                if (newIndex.toString().length === 1) {
                    newIndex = '00' + newIndex;
                } else if (newIndex.toString().length === 2) {
                    newIndex = '0' + newIndex;
                }
                $(item).attr('src', imageDomain + `/web/25ss/assets/letter/${isMobile ? 'mo' : 'pc'}/letter_${newIndex}.png`);
            });
        });

        setStickyContainerHeight($("#intro-section"), introImageDuration / 500);

        const introScene = new ScrollMagic.Scene({
            triggerElement: "#intro-section",
            triggerHook: 0,
            duration: introImageDuration,
            offset: isMobile ? $(window).height() * 0.2 : $(window).height() * 1.8,
        })
        .addTo(controller)
        // .addIndicators({
        //     name: 'Intro Scene',
        //     indent: 20,
        //     colorStart: 'red',
        //     colorEnd: 'blue',
        //     colorTrigger: 'yellow',
        // })
        .on("progress", function (e) {
            const limit = 0.98;
            let index = Math.floor(
                mapValue(e.progress, 0, limit, 0, introImageLength)
            );
            if (index > introImageLength) index = introImageLength;
            introSequenceHolder.find('img').removeClass('active');
            introSequenceHolder.find(`img`).eq(index).addClass('active');
            e.progress > limit
                ? $("#intro-section").addClass("animation-end")
                : $("#intro-section").removeClass("animation-end");
        });

        // [학교 영역] 이미지 노출
        const schoolStartFrame = 24;
        const schoolImageLength = 98 - schoolStartFrame;
        const schoolImageDuration = schoolImageLength * 95;
        const schoolSequenceHolder = $('#school-section .sequence-holder');

        for (let i = 0; i < schoolImageLength; i++) {
            const img = $('<img>');
            let index = i + 1 + schoolStartFrame;
            if (index == 1) img.addClass('active');
            if (index.toString().length === 1) {
                index = '0' + index;
            }
            img.attr('src', imageDomain + `/web/25ss/assets/school/${isMobile ? 'mo' : 'pc'}/school_${index}.png`);
            schoolSequenceHolder.find('.sequence-holder-inner').append(img);
            img.addClass(`index-${index}`);
        }

        schoolSequenceHolder.find('img').eq(0).addClass('active');

        $(window).on("resize", function () {
            $('#school-section .sequence-holder-inner img').each(function (index, item) {
                let newIndex = index + 1 + schoolStartFrame;
                if (newIndex.toString().length === 1) {
                    newIndex = '0' + newIndex;
                }
                $(item).attr('src', imageDomain + `/web/25ss/assets/school/${isMobile ? 'mo' : 'pc'}/school_${newIndex}.png`);
            });
        });

        setStickyContainerHeight($("#school-section"), schoolImageDuration / 600);

        const schoolSceneLimit = 0.45;
        const schoolScene = new ScrollMagic.Scene({
            triggerElement: "#school-section",
            triggerHook: 0,
            duration: schoolImageDuration,
        })
        .addTo(controller)
        .on("progress", function (e) {
            let index = Math.floor(
                mapValue(e.progress, 0, schoolSceneLimit, 0, schoolImageLength)
            );
            if (index > schoolImageLength) index = schoolImageLength;
            schoolSequenceHolder.find('img').removeClass('active');
            schoolSequenceHolder.find(`img`).eq(index).addClass('active');
            e.progress > schoolSceneLimit
                ? $("#school-section").addClass("animation-end")
                : $("#school-section").removeClass("animation-end");
        });

        // 버블과 버튼을 위한 새로운 Scene
        new ScrollMagic.Scene({
            triggerElement: "#school-section",
            triggerHook: 0,
            duration: isMobile ? schoolImageDuration * 1.1 : schoolImageDuration * 1.3,  // 더 긴 duration 설정
        })
        .addTo(controller)
        .on("progress", function (e) {
            const bubbleStart = schoolSceneLimit;
            const bubbleEnd = isMobile ? 0.7 : 0.95;
            const bubbleLength = $('#school-section .bubble-wrap .bubble').length;
            const bubbleTerm = (bubbleEnd - bubbleStart) / bubbleLength;

            // limit 이상 진행 시 버블 노출
            if (e.progress > schoolSceneLimit) {
                $('#school-section .bubble-wrap').addClass('show');

                if(e.progress > bubbleStart && e.progress < bubbleEnd) {
                    const bubbleIndex = Math.floor((e.progress - bubbleStart) / bubbleTerm);
                    if (bubbleIndex >= 0 && bubbleIndex < bubbleLength) {
                        $('#school-section .bubble-wrap .bubble').removeClass('show');
                        $('#school-section .bubble-wrap .bubble').eq(bubbleIndex).addClass('show');
                    }
                }

                if(e.progress > bubbleEnd) {
                    $('#school-section .bubble-wrap').removeClass('show');
                    $('#school-section .btn-wrap').addClass('show');
                } else {
                    $('#school-section .bubble-wrap').addClass('show');
                    $('#school-section .btn-wrap').removeClass('show');
                }
            } else {
                $('#school-section .bubble-wrap').removeClass('show');
                $('#school-section .btn-wrap').removeClass('show');
            }
        });

        // [이미지 영역] 펼치기 버튼 클릭
        $('#btn-fold-image').click(function () {
            $('.img-section').removeClass('fold');
        });

        // 이미지 프리로드 함수를 함수 선언으로 변경
        function getPreloadAnimationImages() {
            const timestamp = new Date().getTime(); // 타임스탬프 생성
            const successImageList = [
                {
                    id: 'success_01',
                    url: imageDomain + '/web/25ss/assets/black_01_opt.gif?t=' + timestamp,
                    type: 'SUCCESS',
                    animation: 'static'
                },
                {
                    id: 'success_02',
                    url: imageDomain + '/web/25ss/assets/black_02_opt.gif?t=' + timestamp,
                    type: 'SUCCESS',
                    animation: 'running'
                },
                {
                    id: 'success_03',
                    url: imageDomain + '/web/25ss/assets/black_03_opt.gif?t=' + timestamp,
                    type: 'SUCCESS',
                    animation: 'catching'
                }
            ];

            const failImageList = [
                {
                    id: 'fail_01',
                    url: imageDomain + '/web/25ss/assets/white_01_opt.gif?t=' + timestamp,
                    type: 'FAIL',
                    animation: 'running'
                },
                {
                    id: 'fail_02',
                    url: imageDomain + '/web/25ss/assets/cheeze_01_opt.gif?t=' + timestamp,
                    type: 'FAIL',
                    animation: 'catching'
                }
            ];

            // successImageList에서 랜덤으로 1개 추출 + 실패 이미지 추가한 총 3개인 배열 생성
            const randomImage = successImageList[Math.floor(Math.random() * successImageList.length)];
            const randomImageList = [randomImage, ...failImageList].sort(() => Math.random() - 0.5);

            const preloadImages = [];
            const imagePromises = randomImageList.map(item => {
                return new Promise((resolve, reject) => {
                    const img = new Image();
                    img.onload = () => resolve({ img, item });
                    img.onerror = reject;
                    img.src = item.url;
                    preloadImages.push(img);
                });
            });

            return {
                promises: imagePromises,
                images: randomImageList
            };
        }

        // 페이지 로드 시점에 이미지 프리로드 시작
        const preloadedImages = getPreloadAnimationImages();
        let isProgressNewAnimation = false;
        let isNewAnimationInit = false;
        // console.log('[preloadedImages]', preloadedImages);

        // Scene을 전역 변수로 선언
        let animationScene;

        function setAnimation() {
            console.log('[애니메이션 초기 셋팅 setAnimation]');

            if(locale == 'JAP') $('#promotion-tabs').prepend('<div class="animation"></div>')

            const randomPositionY = 100;
            const positionTermList = {
                PC: [300, 560, 820],
                MO: [100, 290, 520],
            }

            const positionTerm = isMobile ? positionTermList.MO : positionTermList.PC;

            // 클릭 이벤트 핸들러 추가
            $(document).on('click', '.animation-item', function () {
                const type = $(this).data('type');
                if(type === 'SUCCESS') {
                    $('#modal-form').addClass('show');
                    $('#modal-backdrop').addClass('show');
                } else {
                    $('#modal-form-result').addClass('show');
                    $('#modal-form-result .modal-content').addClass('fail').removeClass('success');
                    $('#modal-backdrop').addClass('show');
                }
            });

            // 전역 변수로 마지막 생성 시간 추가
            let lastAnimationCreated = 0;
            const TIMER_INTERVAL = 5000;
            let lastScrollPosition = 0;
            const SCROLL_THRESHOLD = $(window).height() * 1.2;

            function createNewAnimationItems() {
                if(isProgressNewAnimation) return;
                isProgressNewAnimation = true;
                const newPreloadedImages = getPreloadAnimationImages();

                // 현재 스크롤 위치 계산
                const productWrap = $(locale == 'JAP' ? '#promotion-tabs' : '#product-wrap');
                const scrollProgress = controller.info("scrollPos") - productWrap.offset().top;
                const basePositionY = Math.max(0, scrollProgress);
                const productWrapHeight = productWrap.height();
                // Scene에서 받은 스크롤 방향 사용
                const isScrollingDown = window.currentScrollDirection === 'FORWARD';
                // const topOffset = isScrollingDown ? $(window).height() * 1.2 : -$(window).height() * 1.2;
                const topOffset = 0;

                Promise.all(newPreloadedImages.promises).then(loadedImages => {
                    loadedImages.forEach((loaded, index) => {
                        const { item } = loaded;
                        const sameTypeCount = loadedImages.slice(0, index).filter(l =>
                            l.item.animation === item.animation
                        ).length;

                        const reverseClass = sameTypeCount > 0 ? 'reverse' : '';
                        let finalPosition = basePositionY + positionTerm[index] + topOffset;

                        // 근처에 있는 애니메이션 요소 확인 (±150px 범위 내)
                        const nearbyItems = $('.animation-item').filter(function () {
                            const itemTop = parseInt($(this).css('top'));
                            return Math.abs(itemTop - finalPosition) <= 150;
                        });

                        // 근처에 있는 요소들 중 삭제 대상 확인
                        let shouldCreateNew = true;
                        if (nearbyItems.length > 0) {
                            const currentTime = new Date().getTime();
                            const hasRemovableItem = nearbyItems.toArray().some(item => {
                                const $item = $(item);
                                const itemTime = $item.data('time');
                                const isOld = currentTime - itemTime > 5000;

                                // 삭제 대상인 경우 요소 제거
                                if (isOld) {
                                    try {
                                        $item.off();
                                        $item.remove();
                                        console.log('[Animation] Removed old/non-animated element near new position');
                                        return true; // 삭제된 요소가 있음
                                    } catch (error) {
                                        console.error('[Animation] Error removing element:', error);
                                    }
                                }
                                return false;
                            });

                            // 삭제된 요소가 없는 경우에만 생성 건너뛰기
                            if (!hasRemovableItem) {
                                console.log('[근처에 있는 유효한 애니메이션 요소로 인해 생성 건너뛰기]');
                                shouldCreateNew = false;
                                return; // forEach 콜백에서 빠져나감
                            }
                        }

                        // 새로운 요소 생성 (기존 요소가 없거나 삭제된 경우)
                        if (shouldCreateNew && finalPosition <= productWrapHeight - 300 && finalPosition >= 0) {
                            const createAndAnimate = () => {
                                const currentTime = new Date().getTime();
                                const animationItem = $(
                                    '<button class="animation-item ' + reverseClass + '" id="' +
                                    item.id +
                                    '" type="button" data-type="' +
                                    item.type +
                                    '" data-animation-type="' +
                                    item.animation +
                                    '" data-time="' + currentTime +
                                    '" style="top: ' +
                                    finalPosition +
                                    'px;" data-image-url="' +
                                    item.url +
                                    '" data-is-animation="false"><img src="' +
                                    item.url +
                                    '" alt="' +
                                    item.type +
                                    '"></button>'
                                );
                                $('.animation').append(animationItem);
                                startAnimation(animationItem, item.animation);
                            };

                            if (sameTypeCount > 0) {
                                setTimeout(createAndAnimate, sameTypeCount * 0);
                            } else {
                                createAndAnimate();
                            }
                        }
                    });

                    // 오래된 애니메이션 요소 정리
                    $('.animation-item').each(function() {
                        const $item = $(this);
                        const itemTime = $item.data('time');
                        const currentTime = new Date().getTime();

                        try {
                            // 5초 이상 지난 요소 제거
                            if(currentTime - itemTime > 5000) {
                                $item.off();
                                $item.remove();
                                console.log('[Animation Cleanup] Removed old element');
                            }
                        } catch (error) {
                            console.error('[Animation Cleanup] Error removing element:', error);
                        }
                    });

                    isProgressNewAnimation = false;
                    isNewAnimationInit = true;
                });
            }

            // Scene 초기화 함수
            function initAnimationScene() {
                if (animationScene) {
                    animationScene.destroy(true);
                }

                const productWrap = $(locale == 'JAP' ? '#promotion-tabs' : '#product-wrap');
                const duration = productWrap.height() * 1.5;

                // 전역 변수로 현재 스크롤 방향 저장
                window.currentScrollDirection = 'FORWARD';

                animationScene = new ScrollMagic.Scene({
                    triggerElement: locale == 'JAP' ? '#promotion-tabs' : '#product-wrap',
                    triggerHook: 0.5,
                    duration: duration,
                    refreshInterval: 50
                })
                .addTo(controller)
                .on('progress', function(e) {
                    const currentTime = new Date().getTime();
                    const currentScroll = controller.info("scrollPos");
                    const scrollDiff = Math.abs(currentScroll - lastScrollPosition);

                    // 스크롤 방향 업데이트
                    window.currentScrollDirection = controller.info("scrollDirection");
                    // console.log('[Scroll Direction]', window.currentScrollDirection);

                    if (scrollDiff >= SCROLL_THRESHOLD || currentTime - lastAnimationCreated >= TIMER_INTERVAL) {
                        console.log("[애니메이션 실행]", scrollDiff, currentTime - lastAnimationCreated);
                        createNewAnimationItems();
                        lastScrollPosition = currentScroll;
                        lastAnimationCreated = currentTime;
                    }
                });
            }

            // 상품 로드 완료 후 Scene 업데이트 함수
            function updateAnimationScene() {
                const productWrap = $(locale == 'JAP' ? '#promotion-tabs' : '#product-wrap');
                const newDuration = productWrap.height() * 1.5;

                if (animationScene) {
                    console.log('[updateAnimationScene] 애니메이션 영역 업데이트 updating duration:', newDuration);
                    animationScene.duration(newDuration);
                    animationScene.refresh();
                }
            }

            // 초기 Scene 설정
            initAnimationScene();
        }

        function startAnimation(animationItem, animationType) {
            console.log('[startAnimation] 애니메이션 시작 타입', animationItem.data('type'));

            // gif 프리로드를 위한 이미지 캐싱
            const imgSrc = animationItem.find('img').attr('src');
            const preloadImg = new Image();
            preloadImg.src = imgSrc;

            if (animationType === 'catching') {
                const isReverse = animationItem.hasClass('reverse');

                // gif 로드 완료 후 애니메이션 시작
                preloadImg.onload = () => {
                    // 즉시 catching 클래스 추가하고 gif 재생 시작
                    animationItem.addClass('catching');
                    animationItem.attr('data-is-animation', 'true');

                    // RAF로 다음 프레임에서 애니메이션 시작
                    requestAnimationFrame(() => {
                        if (isReverse) {
                            animationItem.animate({
                                left: window.innerWidth - animationItem.width()
                            }, {
                                duration: 1500,
                                easing: 'easeOutQuad',
                                complete: function() {
                                    setTimeout(() => {
                                        animationItem.animate({
                                            top: animationItem.css('top').split('px')[0] - 120,
                                            left: '100vw'
                                        }, {
                                            duration: 300,
                                            easing: 'easeInOutQuad',
                                            complete: function() {
                                                try {
                                                    // 요소가 여전히 존재하는지 확인
                                                    if (animationItem && animationItem.length) {
                                                        // 모든 이벤트 핸들러 제거
                                                        animationItem.off();
                                                        // 요소 제거
                                                        animationItem.remove();
                                                        console.log('[Animation] Element removed successfully');
                                                    }
                                                } catch (error) {
                                                    console.error('[Animation] Error removing element:', error);
                                                }
                                            }
                                        });
                                    }, 2300);
                                }
                            });
                        } else {
                            animationItem.animate({
                                right: window.innerWidth - animationItem.width()
                            }, {
                                duration: 1500,
                                easing: 'easeOutQuad',
                                complete: function() {
                                    setTimeout(() => {
                                        animationItem.animate({
                                            top: animationItem.css('top').split('px')[0] - 120,
                                            right: '100vw'
                                        }, {
                                            duration: 300,
                                            easing: 'easeInOutQuad',
                                            complete: function() {
                                                try {
                                                    if (animationItem && animationItem.length) {
                                                        animationItem.off();
                                                        animationItem.remove();
                                                        console.log('[Animation] Element removed successfully');
                                                    }
                                                } catch (error) {
                                                    console.error('[Animation] Error removing element:', error);
                                                }
                                            }
                                        });
                                    }, 2300);
                                }
                            });
                        }
                    });
                };
            }

            if (animationType === 'running' || animationType === 'static') {
                preloadImg.onload = () => {
                    requestAnimationFrame(() => {
                        animationItem.addClass(animationType);
                        animationItem.attr('data-is-animation', 'true');

                        setTimeout(() => {
                            animationItem.remove();
                        }, 4500);
                    });
                };
            }
        }

        let pg = 1;

        // checkLocaleLimit을 Promise로 변환
        function checkLocaleLimit(locale) {
            return new Promise((resolve, reject) => {
                $.ajax({
                    url: googleSheetURL,
                    data: {
                        type: 'check',
                        locale: locale,
                        tap: tapParam ? tapParam : tap.id
                    },
                    success: function (res) {
                        console.log('[checkLocaleLimit] res', res);
                        console.log('[checkLocaleLimit] 당첨 제한 수량', res.currentLimit);
                        console.log("[checkLocaleLimit] 전체 수량", res.limits);
                        resolve(res.isAvailable);

                        if(res.result === 'error') {
                            $('#tap-info-desc').html(res.error);
                            const locale_text = {
                                KOR: `${tap.id}회차는 국문몰 미진행`,
                                ENG: `${tap.id}회차는 영문몰 미진행`,
                                JAP: `${tap.id}회차는 일본몰 미진행`,
                            };
                            $('#tap-info-limit').text(`${locale_text[locale]}`);
                            $('#tap-info-limit').removeClass('d-none');
                        }

                        if(res.limits && tap) {
                            const testCurrentLimits = res.limits[tap.id]?.limits;
                            let message = '';
                            Object.keys(testCurrentLimits).forEach(function(key) {
                                message += `<p>${key} : ${testCurrentLimits[key]}개</p>`;
                            });
                            $('#tap-info-desc').html(message);
                            $('#tap-info-limit').removeClass('d-none');
                        }
                    },
                    error: function (err) {
                        console.log("[checkLocaleLimit 이벤트 가능 여부 확인] err", err);
                        reject(err);
                    }
                });
            });
        }

        // setProductSection을 Promise로 변환
        function setProductSectionAsync(tap) {
            return new Promise((resolve) => {
                console.log('[setProductSection] tap', tap);
                const cateNo = tap.cateNo;
                const text = tap.name;
                $('#product-section-title').text(text);
                $('#product-wrap').removeClass('d-none');

                $.get('/25ss-data.html?cate_no=' + cateNo, function () {
                    loadAllProducts(cateNo, () => resolve());
                });
            });
        }

        const animationTest = getUrlParameter('animation');
        const formTest = getUrlParameter("form");

        // 애니메이션 실행 조건을 확인하는 헬퍼 함수
        function shouldRunAnimation(eventType, isEventAvailable, animationTest) {
            return (eventType && eventType !== 'end' && isEventAvailable) || animationTest || (!eventType && isEventAvailable);
        }

        // 비동기 처리를 Promise.all로 통합
        async function initializeAnimation() {
            console.log('[initializeAnimation]');
            try {
                if (!tap) return;

                let isEventAvailable = await checkLocaleLimit(locale);
                isEventAvailable = false;
                console.log('[이벤트 강제 비활성화]', isEventAvailable);
                if(tapParam) {
                    isEventAvailable = await checkLocaleLimit(locale);
                    console.log('[이벤트 확인 후 활성화 - 테스트 파라미터 있음]', isEventAvailable);
                }

                if(tap.id == 5) {
                    isEventAvailable = false;
                }

                if (locale !== 'JAP') {
                    await setProductSectionAsync(tap);
                }

                if (shouldRunAnimation(eventType, isEventAvailable, animationTest)) {
                    setAnimation();
                }
            } catch (error) {
                console.error('Animation initialization failed:', error);
            }
        }

        if (tap) {
            initializeAnimation();
        } else {
            // 상품만 로드
            console.log("[init] 상품만 로드");
            if(locale !== 'JAP') {
                setProductSectionAsync(tapList[0], function () {});
            } else {
                // [로컬 스토리지에 저장된 스크롤 위치 가져오기]
                const scrollPosition = localStorage.getItem("scrollPosition");
                console.log("[로컬 스토리지] 스크롤 위치", scrollPosition);
                if (scrollPosition) {
                    console.log("[로컬 스토리지] 스크롤 위치 이동");
                    window.scrollTo(0, scrollPosition);
                    localStorage.removeItem("scrollPosition");
                }
            }
        }

        // loadAllProducts 함수를 전역 범위로 이동
        async function loadAllProducts(cateNo, callback) {
            // 첫 페이지를 로드하여 전체 페이지 수 확인
            const firstPage = await $.get('/25ss-data.html?cate_no=' + cateNo + '&page=1');
            const lastPage = $(firstPage).find('#paging ul li:last-child a').text();

            // 1페이지부터 마지막 페이지까지 모든 상품 로드
            for (let i = 1; i <= lastPage; i++) {
                const res = await $.get('/25ss-data.html?cate_no=' + cateNo + '&page=' + i);
                const productList = $(res).find('#product');
                $('.product-list').append(productList);
            }

            // 모든 상품을 로드했으므로 더보기 버튼 숨김
            $('#btn-more-product').hide();

            // // Scene 업데이트
            if (animationScene) {
                console.log('[loadAllProducts] 애니메이션 영역 업데이트');
                animationScene.refresh();
            }

            if (callback) callback();

            // [로컬 스토리지에 저장된 스크롤 위치 가져오기]
            const scrollPosition = localStorage.getItem('scrollPosition');
            console.log('[로컬 스토리지] 스크롤 위치', scrollPosition);
            if (scrollPosition) {
                console.log('[로컬 스토리지] 스크롤 위치 이동');
                window.scrollTo(0, scrollPosition);
                localStorage.removeItem('scrollPosition');
            }
        }

        // [주소 검색] 버튼 클릭
        $('#btn-search-address').on('click', function () {
            new daum.Postcode({
                oncomplete: function (data) {
                    const address = data.address;
                    const zonecode = data.zonecode;
                    $('input[name="address-basic"]').val(address);
                    $('input[name="zipcode"]').val(zonecode);

                    $(".input-group.address-group").removeClass("error");
                }
            }).open();
        });

        // [개인정보취급방침] 열기 버튼 클릭
        $('#btn-agree-privacy').click(function () {
            $('.privacy-content').toggleClass('show');
            $(this).text($(this).text() === message[locale].viewPrivacy ? message[locale].closePrivacy : message[locale].viewPrivacy);
        });

        if(formTest == 'test') {
            $('#modal-form').addClass('show');
            $('#modal-backdrop').addClass('show');

            $('input[name="name"]').val('테스트 유저');
            $('input[name="phone"]').val('01012345678');
            $('input[name="email"]').val('test@test.com');
            $('input[name="zipcode"]').val('12345');
            $('input[name="address-basic"]').val('서울특별시 강남구 테스트로 123-45');
            $('input[name="address-detail"]').val('101동 101호');
            $('input[name="request"]').val('테스트 요청사항');
            $('input[name="City"]').val('서울특별시');
            $('input[name="state"]').val('강남구');
            $('input[name="country"]').val('대한민국');

        }

        // [제출하기] 버튼 클릭
        $('#btn-submit-form').click(function () {
            console.log('[제출하기]');
            const form = $('#modal-form form');
            let isValid = true;

            $('.input-group.required').each(function() {
                const $group = $(this);
                const fieldType = $group.data('field-type');
                console.log('[single]', $group);

                if (fieldType === 'single') {
                    // 단일 필드 검사
                    const $input = $group.find('input[data-required="true"]');
                    if ($input.val().trim() === '' || $input.val().trim() === null) {
                        $input.addClass('error');
                        isValid = false;
                    } else {
                        $input.removeClass('error');
                    }
                }
                else if (fieldType === 'multiple') {
                    // 복수 필드 검사
                    $group.find('input[data-required="true"]').each(function() {
                        const $input = $(this);
                        if ($input.val().trim() === '' || $input.val().trim() === null) {
                            $input.addClass('error');
                            isValid = false;
                        } else {
                            $input.removeClass('error');
                        }
                    });
                }
            });

            if(locale !== 'KOR') {
                // 국가 선택
                if($('select[name="country"]').val() === '') {
                    $('select[name="country"]').addClass('error');
                    isValid = false;
                }

                // 주 선택
                if($('select[name="state"]').length !== 0) {
                    if($('select[name="state"]').val() === '') {
                        $('select[name="state"]').addClass('error');
                        isValid = false;
                    }
                }
            }

            console.log($("#agree-privacy").is(':checked'));

            // 개인정보 동의
            if($('#agree-privacy').is(':checked') === false) {
                isValid = false;
            }


            // 제출하기 버튼 클릭
            if(isValid) {
                submitForm();
            } else {
                alert(message[locale].formAllRequired);
            }
        });

        $(document).on('input', '.input-group.required input', function () {
            const input = $(this);
            const value = input.val();

            if (value.trim() !== '') {
                input.parent().removeClass("error");
                input.removeClass('error');
            } else {
                input.parent().addClass("error");
                input.addClass('error');
            }
        });

        $(document).on('change', 'select[name="country"]', function () {
            if($(this).val() === '') {
                $(this).addClass('error');
            } else {
                $(this).removeClass('error');
            }
        });

        $(document).on('change', 'select[name="state"]', function () {
            if($(this).val() === '') {
                $(this).addClass('error');
            } else {
                $(this).removeClass('error');
            }
        });

        // [구글 시트 제출]
        function submitForm() {
            $('#btn-submit-form').prop('disabled', true).text(message[locale].formLoading);
            let address = '';

            if(locale === 'JAP') {
                // 일본어 주소 표기 순서로 조합
                const japanAddress = [
                    "zipcode",  // 우편번호
                    "state",    // 도도부현
                    "city",     // 시구정촌
                    "address-basic", // 주소
                    "address-detail" // 상세주소
                ];

                $.each(japanAddress, function(index, item) {
                    let input = $('input[name="' + item + '"]');
                    let value = input.val();

                    // 우편번호인 경우 〒 추가
                    if(item === 'zipcode' && value) {
                        value = '〒' + value;
                    }

                    // select 요소인 경우 선택된 텍스트 가져오기
                    if(item === 'state') {
                        input = $('select[name="state"]');
                        value = input.find('option:selected').text();
                    }

                    if(input.length !== 0 && input.val() !== '') {
                        address += (index === 0 ? '' : ' ') + value;
                    }
                });
            } else {
                // 기존 주소 조합 로직
                const addAddress = [
                    "address-basic",
                    "address-detail",
                    "state",
                    "city",
                    "country",
                ];

                $.each(addAddress, function(index, item){
                    let input = $('input[name="' + item + '"]');
                    let value = input.val();
                    if(item == 'state') {
                        if($('select[name="state"]').length !== 0) {
                            input = $('select[name="state"]')
                            value = input.find('option:selected').text();
                        } else {
                            input = $('input[name="state"]')
                            value = input.val();
                        }
                    }
                    if(item == 'country') {
                        input = $('select[name="country"]')
                        value = input.find('option:selected').text();
                    }
                    console.log('[submitForm] input', value);
                    if(input.length !== 0 && input.val() !== '') {
                        address += ` ${value}`;
                    }
                })
            }

            let data = {
                receiverName: locale === 'JAP'
                    ? ($('input[name="lastname"]').val() + ' ' + $('input[name="firstname"]').val())
                    : $('input[name="name"]').val(),
                address: address,
                phone: $('input[name="phone"]').val(),
                email: $('input[name="email"]').val(),
                request: $('input[name="request"]').val(),
                zipcode: $('input[name="zipcode"]').val(),
                locale: locale,
                type: 'submit',
                tap: tapParam ? tapParam : tap.id,
                url: window.location.href
            };

            if(animationTest == 'test' || formTest == 'test') {
                data.tap = 'test';
            };

            console.log('[submitForm] 제출 데이터', data);

            $.ajax({
                type: "GET",
                url: googleSheetURL,
                data: data,
                success: function (response) {
                    console.log('[submitForm] 제출 결과', response);
                    if (response.result == "success") {
                    $("#modal-form").removeClass("show");
                    $("#modal-form-result").addClass("show");
                    $("#modal-form-result .modal-content")
                        .addClass("success")
                        .removeClass("fail");
                    $("#modal-backdrop").addClass("show");
                    } else {
                        const errorMessage = response.message;
                        alert(errorMessage);
                        $('#btn-submit-form').prop('disabled', false).text(message[locale].formSubmit);
                    }
                },
                error: function (response) {
                    const errorMessage = response.message;
                    console.log('[submitForm] 제출 결과 오류', errorMessage);
                },
            });
        }

        // [모달 열기] 버튼 클릭
        $('#btn-open-modal').click(function () {
            $('#modal-form').addClass('show');
            $('#modal-backdrop').addClass('show');
        });

        // [모달 닫기] 버튼 클릭
        $('.modal-close, .btn-modal-close').click(function () {
            $('.modal').removeClass('show');
            $('#modal-backdrop').removeClass('show');
        });

        // [작은 모달 열기] 버튼 클릭
        $('#btn-open-modal-small').click(function () {
            $('#modal-form-result').addClass('show');
            $('#modal-backdrop').addClass('show');
        });

        // [친구 공유하기] 버튼 클릭
        const shareData = {
            title: message[locale].shareTitle,
            text: message[locale].shareText,
            url: window.location.href
        };

        $('.btn-share-catch').on('click', async () => {
            if (navigator.share) {
                try {
                    await navigator.share(shareData);
                } catch (err) {
                    console.error('공유에 실패했습니다:', err);
                }
            }
        });

        // [상품] 클릭 이벤트
        $(document).on('click', '#product .item a, #promotion-tabs .promotion__tabs-card a', function (e) {
            e.preventDefault();
            const href = $(this).attr('href');
            //현재 스크롤값을 로컬스토리지에 저장하고 이동
            const scrollPosition = window.scrollY;
            console.log('[상품] 클릭 이벤트', scrollPosition);
            localStorage.setItem('scrollPosition', scrollPosition);
            window.location.href = href;
        });
    });

    // Keep function declarations outside document.ready
    function getUrlParameter(sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;
        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
    };

    function setStickyContainerHeight(container, duration, callback) {
        var vh = window.innerHeight;
        var height = container.height();
        var new_height = vh * duration;
        container.css("height", new_height);
        if (callback) callback();
    }

    function mapValue(value, inMin, inMax, outMin, outMax) {
        return ((value - inMin) * (outMax - outMin)) / (inMax - inMin) + outMin;
    }

    // [날짜 포맷 함수]
    function formatDateTime(date, includeSeconds = false) {
        const options = {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
            timeZone: 'Asia/Seoul'
        };

        if (includeSeconds) {
            options.second = '2-digit';
        }

        return new Date(date).toLocaleString('ko-KR', options);
    }
})(jQuery);